import React from 'react';
import { Navigate, useLocation } from 'react-router';
import { useAuth } from '../contexts/AuthContext';

interface PublicRouteProps {
  children: React.ReactNode;
  forRole?: 'client' | 'partner';
}

export const PublicRoute: React.FC<PublicRouteProps> = ({ children, forRole }) => {
  const { isAuthenticated, user, isLoading } = useAuth();
  const location = useLocation();

  // Show loading while authentication is being checked
  if (isLoading && !isAuthenticated) {
    // Determine spinner color based on route or forRole
    const isPartnerRoute = forRole === 'partner' || location.pathname.startsWith('/partner');
    const spinnerColor = isPartnerRoute ? 'border-partner' : 'border-primary';

    return (
      <div className="flex items-center justify-center h-screen">
        <div
          className={`animate-spin rounded-full size-12 md:size-32 border-b-2 ${spinnerColor}`}
        ></div>
      </div>
    );
  }

  if (isAuthenticated) {
    // If user is authenticated, redirect to appropriate dashboard
    const dashboardPath = user?.role === 'partner' ? '/partner/dashboard' : '/client/dashboard';

    // Предотвращаем циклические редиректы - проверяем точно куда собираемся идти
    const redirectTo = dashboardPath;

    // Если мы уже на нужной странице или страница аутентификации, не редиректим
    if (
      location.pathname === redirectTo ||
      location.pathname.includes('/sign-in') ||
      location.pathname.includes('/sign-up') ||
      location.pathname.includes('/forgot-password') ||
      location.pathname.includes('/reset-password')
    ) {
      // Если это страница входа, но пользователь авторизован, редиректим только один раз
      if (location.pathname.includes('/sign-in') || location.pathname.includes('/sign-up')) {
        return <Navigate to={redirectTo} replace />;
      }

      return <>{children}</>;
    }

    return <Navigate to={redirectTo} replace />;
  }

  return <>{children}</>;
};
